module.exports = __webpack_public_path__ + "static/media/flashcard.a6d5db6c.jpg";